import { style } from '@vanilla-extract/css'

const card = style({
  backgroundColor: 'white',
  boxShadow: '0px 8px 16px 0px #C5C5C50D',
  borderRadius: '16px',
  padding: '16px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
})

const question = style({
  fontSize: '15px',
  fontWeight: '700',
  lineHeight: '1.5',
  color: '#252525',
})

const answer = style({
  fontSize: '15px',
  lineHeight: '1.5',
  color: '#252525',
})

export const styles = {
  card,
  question,
  answer,
}
